<template>
  <HeaderLayout/>
  <MainLayout/>
</template>

<script>
import HeaderLayout from "@/components/header";
import MainLayout from "@/components/main";


export default {
  name: "Page",
  components: {
    HeaderLayout,
    MainLayout,
  }
}
</script>